document.addEventListener('turbolinks:load', function() {
  $('.dropdown-submenu a.test').on("click", function(e) {
    $(this).next('ul').toggle();
    e.stopPropagation();
    return e.preventDefault();
  });
});
